import React, { useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import { Cta } from '../components/Cta.js';
import { ReactComponent as Check } from "../assets/loginPage/check.svg";
import { ReactComponent as Group31 } from "../assets/loginPage/group-31.svg";
import { ReactComponent as Mail } from "../assets/loginPage/mail.svg";
import maskGroup from "../assets/loginPage/mask-group.png";
import { ReactComponent as Profile } from "../assets/loginPage/profile.svg";
import "../css/OnBoardingPage.css";
import { auth } from '../firebase';
import { useEffect } from 'react';

/* This page hasn't been implemented yet. It may get deleted and its functionality moved. 

The concept of this page is to have users add their location, interests and bio to their profile.

Location and bio can just be added by editing the profile page. 

It might make better sense to only have a popup asking for their interests upon the first log in. These interests will be shown and users can click 
on which are relevant to them. 
*/

const OnboardingPage = () => {
    const [formData, setFormData] = useState({
        location: '',
        interests: '',
        bio: '' 
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleNext = () => {};

    // upon loading, console log the user information
    useEffect(() => {
        console.log(auth.currentUser);
    }, []);

    return (
    <div className="element-login-sign-up">
            <div className="overlap">
                <div className="frame">
                    <div className="div">
                        <Check className="check responsive-img" />

                        <div className="frame-2">
                            <p className="text-wrapper">Begin Your Journey to Healing</p>

                            <p className="p">
                                Find solace and connection in our community. The JoyNet App is a
                                sanctuary where conversations heal and uplift.
                            </p>
                        </div>
                    </div>

                    <div className="frame-3">
                        <Check className="check responsive-img" />

                        <div className="frame-2">
                            <p className="text-wrapper-2">
                                Simplicity in Connection, Richness in Experience
                            </p>

                            <p className="p">
                                Signing up is just the start. Join chatrooms, connect with
                                kindred spirits, and share in the celebration of Black Joy.
                            </p>
                        </div>
                    </div>
                </div>

                <img className="mask-group responsive-img" alt="Mask group" src={maskGroup} />
            </div>

            <div className="group-container">
                <Group31 className="group responsive-img" />
                <span className="joynet-text">JoyNet</span>
            </div>

        <div className="text-container">
            <p className="text-wrapper-3">
                Just one step more
            </p>

            <p className="welcome-to-your">
                YOU'RE DOING GREAT
            </p>

            <form onNext={handleNext} className="login-form">
                <TextField
                    name="location"
                    label="Location"
                    variant="outlined"
                    value={formData.name}
                    onChange={handleChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Profile className="input-icon" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ mb: 2, width: '150%', right: '7%' }}
                />
                <TextField
                    name="interests"
                    label="Interests"
                    variant="outlined"
                    value={formData.interests}
                    onChange={handleChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Mail className="input-icon" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ mb: 2, width: '150%', right: '7%' }}
                />
                <TextField
                    name="bio"
                    label="Bio"
                    variant="outlined"
                    value={formData.bio}
                    onChange={handleChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Mail className="input-icon" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ mb: 2, width: '150%', right: '7%'}}
                />
                
                <Cta
                    type="next"
                    text="NEXT"
                    className="login-cta"
                    onClick={handleNext}
                    style={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        position: 'relative',
                        left: '68%',
                        transform: 'translateX(-50%)',
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}
                />
            </form>

        </div>
    </div> 
    );
};

export default OnboardingPage;














